const local = '_POLICE_SESSION_CONFIG_'

export default {
	set(config) {
		var string = JSON.stringify(config)
		sessionStorage.setItem(local, string)
	},

	get(posicao) {
		// se existir config do cliente
		if (sessionStorage.getItem(local) != null) {
			var config = JSON.parse(sessionStorage.getItem(local))
			return _.isNil(posicao) ? config : config[posicao]
		} else {
			return null
		}
	}
}
